import { Injectable } from '@angular/core';


@Injectable()
export class GetDeviceService {

  constructor() {}

    public getBrowser() {
        if ((navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR')) !== -1) {
            return ' Opera';
        } else if ((navigator.userAgent.indexOf('MSIE') !== -1)) {
            return ' IE';
        } else if ((navigator.userAgent.indexOf('Edge') !== -1)) {
            return ' Edge';
        } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
            return ' Chrome';
        } else if (navigator.userAgent.indexOf('Safari') !== -1) {
            return ' Safari';
        } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
            return ' Firefox';
        }  else {
            return 'unknown ';
        }
    }

    public getOS() {
        if (navigator.appVersion.indexOf('Win') !== -1) {
            return ' Windows ';
        } else if (navigator.appVersion.indexOf('iPhone') !== -1) {
            return ' iPhone ';
        } else if (navigator.appVersion.indexOf('Mac') !== -1) {
            return ' MacOS ';
        } else if (navigator.appVersion.indexOf('X11') !== -1) {
            return ' UNIX ';
        } else if (navigator.appVersion.indexOf('Android') !== -1) {
            return ' Android ';
        } else if (navigator.appVersion.indexOf('Linux') !== -1) {
            return ' Linux ';
        } else {
            return 'unknown ';
        }
    }

    public getOSVersion() {
        if (navigator.appVersion.indexOf('NT 5.1') !== -1) {
            return ' Windows XP ';
        } else if (navigator.appVersion.indexOf('NT 6.0') !== -1) {
            return ' Windows Vista ';
        } else if (navigator.appVersion.indexOf('NT 6.1') !== -1) {
            return ' Windows 7 ';
        } else if (navigator.appVersion.indexOf('NT 6.2') !== -1) {
            return ' Windows 8 ';
        } else if (navigator.appVersion.indexOf('NT 6.3') !== -1) {
            return ' Windows 8.1 ';
        } else if (navigator.appVersion.indexOf('NT 10.0') !== -1) {
            return ' Windows 10 ';
        } else {
            return ' unknown ';
        }
    }

    public getDevice() {
        if (navigator.userAgent.match(/mobile/i)) {
            return ' Mobile /';
        } else if (navigator.userAgent.match(/iPad|Android|Touch/i)) {
            return ' Tablet /';
        } else {
            return ' Desktop /';
        }
    }
}
